"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var crypto_1 = require("crypto");

var bn_js_1 = __importDefault(require("bn.js"));

var constants_1 = require("./constants");

var helpers_1 = require("./helpers");

function randomHex(size) {
  return toHex(crypto_1.randomBytes(size));
}

exports.randomHex = randomHex;

function getHexBytesSize(value) {
  var result = 0;

  if (isHex(value, 'data')) {
    result = (value.length - 2) / 2;
  }

  return result;
}

exports.getHexBytesSize = getHexBytesSize;

function concatHex() {
  for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return "".concat(constants_1.HEX_PREFIX).concat(values.map(function (value) {
    return toHex(value).slice(2);
  }).join(''));
}

exports.concatHex = concatHex;

function padHex(value, bytes, direction) {
  var result = null;
  var hex = toHex(value);

  if (hex) {
    var length = bytes * 2;
    var base = hex.slice(2);

    if (base.length < length) {
      var pad = '0'.repeat(length - base.length);

      switch (direction) {
        case 'left':
          result = "".concat(pad).concat(base);
          break;

        case 'right':
          result = "".concat(base).concat(pad);
          break;
      }

      result = "".concat(constants_1.HEX_PREFIX).concat(result);
    } else {
      result = hex;
    }
  }

  return result;
}

exports.padHex = padHex;

function padHexLeft(value) {
  var bytes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
  return padHex(value, bytes, 'left');
}

exports.padHexLeft = padHexLeft;

function padHexRight(value) {
  var bytes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
  return padHex(value, bytes, 'right');
}

exports.padHexRight = padHexRight;

function toHex(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0x';
  var forceEven = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var result = null;

  if (!helpers_1.isEmpty(value)) {
    if (isHex(value)) {
      result = value;
    } else {
      switch (typeof value) {
        case 'boolean':
          result = value ? '1' : '0';
          break;

        case 'string':
          result = Buffer.from(value, constants_1.BUFFER_TEXT_ENCODING).toString('hex');
          break;

        case 'number':
          result = value.toString(16);
          break;

        case 'object':
          if (bn_js_1.default.isBN(value)) {
            result = value.toString('hex');
          } else if (Buffer.isBuffer(value)) {
            result = value.toString('hex');
          }

          break;
      }

      if (result) {
        result = "".concat(constants_1.HEX_PREFIX).concat(result);
      }
    }

    if (result && forceEven && result.length % 2 !== 0) {
      result = "".concat(constants_1.HEX_PREFIX, "0").concat(result.slice(2));
    }
  }

  return result || defaultValue;
}

exports.toHex = toHex;

function isHex(value) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var result = false;

  if (value && typeof value === 'string' && value.startsWith(constants_1.HEX_PREFIX)) {
    value = value.toLowerCase();
    var length = value.length;

    if (!type || type === 'quantity' && length > 2 || type === 'data' && length % 2 === 0) {
      if (type === 'quantity' && value.charCodeAt(2) === 48) {
        result = length === 3;
      } else {
        result = true;

        for (var i = 2; i < length; i += 1) {
          var charCode = value.charCodeAt(i);

          if (!(charCode >= 97 && charCode <= 102) && !(charCode >= 48 && charCode <= 57)) {
            result = false;
            break;
          }
        }
      }
    }
  }

  return result;
}

exports.isHex = isHex;